import React from "react";
import {
  Isvg,
  Spinner,
  NotebookDialog,
  Tree,
  TreeItem,
  MenuMixin
} from "../../components";
import {
  MarkerStore,
  BookStore,
  HighlightStore,
  Dispatcher,
  BookUtils
} from "../../flux";

class OneNoteContainer extends React.Component {
  constructor(props) {
    super(props);
    const book = BookStore.get(props.isbn);
    this.state = {
      accessToken: false,
      showPreviewOptions: false,
      showExportComplete: false,
      loader: false,
      createdByName: "",
      createNotebook: false,
      signOut: "",
      oneNoteAppID: Fraction.Environment.oneNoteAppID
    };

    this._updateModalSize = this._updateModalSize.bind(this);
    this._getOneNoteNoteBooks = this._getOneNoteNoteBooks.bind(this);
    this._receiveMessage = this._receiveMessage.bind(this);
    this._getOneNoteToken = this._getOneNoteToken.bind(this);
    this._onSubmit = this._onSubmit.bind(this);
    this._autoCreateSection = this._autoCreateSection.bind(this);
    this._viewInOneNote = this._viewInOneNote.bind(this);
    this._signOutOneNote = this._signOutOneNote.bind(this);
    this._selectSection = this._selectSection.bind(this);
    this._previewPrintNotes = this._previewPrintNotes.bind(this);
    this._optionsPrintNotes = this._optionsPrintNotes.bind(this);
  }

  _updateModalSize() {
    var modalHeaderHeight = document.getElementById("modal-header")
      .offsetHeight;
    var modalContentHeight = document.getElementById("modal-content-container")
      .offsetHeight;
    if (Fraction.Helpers.isSmallScreen()) {
      document.getElementById("modal-container").style.height = "100%";
    } else if (this.state.showExportComplete || this.state.createNotebook) {
      document.getElementById("modal-container").style.height = "396px";
    } else if (this.state.showPreviewOptions) {
      document.getElementById("modal-container").style.height = "440px";
    } else {
      document.getElementById("modal-container").style.height = "480px";
    }
  }

  renderSignIn() {
    return (
      <div className="one-note-sign-in">
        <div className="one-note-logo">
          <Isvg className="" src="/img/onenote_logo.svg" />
        </div>
        <button
          onClick={this._getOneNoteToken}
          data-value="microsoft"
          className="noButton one-note-button large"
        >
          {i18n.t("one-note.sign-in-microsoft")}
        </button>
        <button
          onClick={this._getOneNoteToken}
          data-value="other"
          className="noButton one-note-button large"
        >
          {i18n.t("one-note.sign-in-other")}
        </button>
        {this.state.loader && <Spinner />}
      </div>
    );
  }

  _getOneNoteNoteBooks(accessToken) {
    Jigsaw.User.oneNote(
      accessToken,
      { path: "/me/notes/sections" },
      response => {
        if (response.isSuccess()) {
          var oneNoteSections = JSON.parse(response.data.response[0]).value;
          var oneNoteNoteBooks = {};
          if (oneNoteSections.length === 0) {
            this.setState(
              { createNotebook: true, loader: false },
              this._updateModalSize
            );
          } else {
            oneNoteSections.map(section => {
              if (oneNoteNoteBooks[section.parentNotebook.id]) {
                oneNoteNoteBooks[section.parentNotebook.id].sections.push(
                  section
                );
              } else {
                oneNoteNoteBooks[section.parentNotebook.id] = {
                  sections: [section],
                  name: section.parentNotebook.name
                };
              }
            });
            var notebookList = Object.keys(oneNoteNoteBooks).map(id => {
              return oneNoteNoteBooks[id];
            });
            this.setState(
              {
                notebookList,
                selectedSection: notebookList[0].sections[0],
                createdByName: notebookList[0].sections[0].createdBy,
                loader: false,
                createNotebook: false
              },
              this._updateModalSize
            );
          }
        }
      }
    );
  }

  _receiveMessage(message) {
    if (message.data.accessToken) {
      this.setState(
        { loader: true, accessToken: message.data.accessToken },
        this._updateModalSize
      );
      this._myWindow.close();
      this._getOneNoteNoteBooks(message.data.accessToken);
    }
  }

  _getOneNoteToken(e) {
    var value = e.currentTarget.getAttribute("data-value");
    //Old ID just in case we need it / can delete if not
    //var clientID = "aab04edc-0961-4562-bc54-d3ecea48ee87";
    var clientID = this.state.oneNoteAppID;
    var param = encodeURIComponent(
      "?opener=" +
        encodeURIComponent(window.location.origin) +
        "&clientID=" +
        clientID
    );
    var redirectURI = encodeURIComponent(
      window.location.protocol +
        Fraction.Environment.bookshelfURL +
        "/static/onenote/"
    );
    var url;
    if (value === "microsoft") {
      url =
        "https://login.live.com/oauth20_authorize.srf?client_id=" +
        clientID +
        "&display=page&locale=en&redirect_uri=" +
        redirectURI +
        "&response_type=token&scope=office.onenote%20wl.signin%20office.onenote_create&state=" +
        param;
      this.setState({ signOut: "microsoft" });
    } else if (value === "other") {
      url =
        "https://login.microsoftonline.com/common/oauth2/authorize?client_id=" +
        clientID +
        "&display=page&locale=en&redirect_uri=" +
        redirectURI +
        "&response_type=id_token&scope=wl.signin%20office.onenote_create&state=" +
        param +
        "&nonce=true";
      this.setState({ signOut: "other" });
    }
    this._myWindow = window.open(
      url,
      "testing",
      "height=480, width=565, resizable=0"
    );
    window.addEventListener("message", this._receiveMessage);
  }

  _onSubmit(selectedHighlights, isbn) {
    if (!this.state.loader) {
      const book = BookStore.get(this.props.isbn);
      var bookTitle = book.title + i18n.t("one-note.chapter-title");
      var selectedSection = this.state.selectedSection.id;
      var renderPreviewNotesHTML = document.getElementById("notesPreview")
        .innerHTML;
      this.setState({ loader: true });
      Jigsaw.User.oneNote(
        this.state.accessToken,
        {
          path: "/me/notes/sections/" + selectedSection + "/pages",
          method: "POST",
          body:
            '<?xml version="1.0" encoding="utf-8" ?><html><head><title>' +
            bookTitle +
            "</title></head><body>" +
            renderPreviewNotesHTML +
            "</body></html>"
        },
        function(response) {
          if (response.isSuccess()) {
            this.setState(
              { showExportComplete: true, loader: false },
              this._updateModalSize
            );
            this.props.changeModalTitle(i18n.t("one-note.export-complete"));
          }
        }.bind(this)
      );
      // Hey look we exported to OneNote! Let's log that
      Fraction.Reporter.gaEvent("/onenote-submitted");
    }
  }

  _autoCreateSection() {
    if (!this.state.loader) {
      this.setState({ loader: true });
      Jigsaw.User.oneNote(
        this.state.accessToken,
        {
          path: "/me/notes/pages/",
          method: "POST",
          body:
            '<?xml version="1.0" encoding="utf-8" ?><html><head><title>Default Page</title></head><body>Default Content</body></html>'
        },
        function(response) {
          if (response.isSuccess()) {
            this._getOneNoteNoteBooks(this.state.accessToken);
          }
        }.bind(this)
      );
    }
  }

  _viewInOneNote(e) {
    e.preventDefault();
    if (this.state.signOut === "microsoft") {
      Fraction.Helpers.Locations.safeRedirect(
        Fraction.Brand.OneNote.url_microsoft,
        "_blank"
      );
    } else if (this.state.signOut === "other") {
      Fraction.Helpers.Locations.safeRedirect(
        Fraction.Brand.OneNote.url_other,
        "_blank"
      );
    }
  }

  renderCreateNoteBook() {
    return (
      <div className="one-note-create-notebook">
        <h3>{i18n.t("one-note.create-notebook")}</h3>
        <div className="one-note-logo">
          <Isvg className="" src="/img/onenote_logo.svg" />
        </div>
        <p>{i18n.t("one-note.no-notebooks")}</p>
        <button
          onClick={this._autoCreateSection}
          className="noButton one-note-button large"
        >
          {i18n.t("one-note.create-notebook")}
        </button>
        {this.state.loader && <Spinner />}
      </div>
    );
  }

  _signOutOneNote(e) {
    var clientID = this.state.oneNoteAppID;
    var redirectURI = "https://login.live.com/oauth20_desktop.srf";
    var url;
    if (this.state.signOut === "microsoft") {
      url =
        "https://login.live.com/oauth20_logout.srf?client_id=" +
        clientID +
        "&redirect_uri=" +
        redirectURI +
        "";
    } else if (this.state.signOut === "other") {
      url = "https://login.microsoftonline.com/logout.srf";
    }
    this._myWindow = window.open(
      url,
      "closing",
      "height=480, width=565, resizable=0"
    );
    Fraction.Helpers.delayTimeout(
      function() {
        this._myWindow.close();
        Fraction.Helpers.removeModal();
      }.bind(this),
      1000
    );
  }

  renderExportComplete() {
    return (
      <div className="one-note-export-complete">
        <div className="one-note-check-complete">
          <span className="offScreen">
            {i18n.t("one-note.export-complete-icon")}
          </span>
          <Isvg className="" src="/img/success.svg" />
        </div>
        <button
          onClick={this._viewInOneNote}
          className="noButton one-note-button large"
        >
          {i18n.t("one-note.view-one-note")}
        </button>
        <div className="one-note-footer">
          <span>
            {i18n.t("one-note.signed-into-onenote-as", {
              user: this.state.createdByName
            })}
          </span>
          <button onClick={this._signOutOneNote} className="noButton">
            {i18n.t("global-bar.sign-out")}
          </button>
        </div>
      </div>
    );
  }

  renderPreviewNotes() {
    var myNotes = function(note) {
      var content = [];
      var style = note.subscribed
        ? { textDecoration: "underline" }
        : { backgroundColor: note.vstColor, padding: "3px" };
      var chapterTitle = BookUtils.getChapterTitleForCFI(
        this.props.isbn,
        note.cfi,
        { maxLevel: 1 }
      );
      content.push(
        <div className="note">
          {this.lastChapterTitle !== chapterTitle && (
            <div style={{ fontWeight: 700, paddingBottom: "5px" }}>
              {chapterTitle}
            </div>
          )}
          <div style={{ paddingBottom: "5px", fontSize: "1.2rem" }}>
            {note.userInitials && (
              <span style={{ fontWeight: 700 }}>{note.userInitials}</span>
            )}
            <span>{i18n.t("one-note.highlighter-header")}</span>
            <span>{MarkerStore.getAll().markerHash[note.markerId].label}</span>
          </div>
          <div style={style}>
            <span>{note.selectedText}</span>
          </div>
          <div
            style={{ color: "#949494", paddingTop: "5px", fontSize: "1.2rem" }}
          >
            {note.noteText}
          </div>
        </div>
      );
      this.lastChapterTitle = chapterTitle;
      return content;
    }.bind(this);

    this.lastChapterTitle = false;
    var seletedHighlights = this.state.selectedHighlights;
    if (
      seletedHighlights &&
      (seletedHighlights.mine.length > 0 || seletedHighlights.theirs.length > 0)
    ) {
      var renderMyNotes = this.state.selectedHighlights.mine.map(myNotes);
      var renderTheirNotes = this.state.selectedHighlights.theirs.map(myNotes);
      var headerStyle = { fontSize: "1.8rem", fontWeight: 400 };
      return (
        <div>
          {seletedHighlights.mine.length > 0 && (
            <div className="notes-preview-container">
              <h3 style={headerStyle}>
                {i18n.t("one-note.my-notes-highlights")}
              </h3>
              {renderMyNotes}
            </div>
          )}
          {seletedHighlights.theirs.length > 0 && (
            <div className="notes-preview-container">
              <h3 style={headerStyle}>
                {i18n.t("one-note.their-notes-highlights")}
              </h3>
              {renderTheirNotes}
            </div>
          )}
          {this.state.loader && <Spinner />}
        </div>
      );
    }
    return (
      <div className="notes-preview-container">
        <span>{i18n.t("one-note.no-hightlights-selected")}</span>
      </div>
    );
  }

  renderDefaultLoc() {
    if (this.state.notebookList) {
      var renderOneNoteNotebooks = this.state.notebookList.map(notebook => {
        return {
          title: notebook.name,
          children: notebook.sections.map(section => {
            return {
              title: section.name,
              callback: () => {
                this._selectSection(section);
              },
              children: [],
              hideNumbers: true
            };
          }),
          callback: () => {
            const renderInterval = setInterval(() => this.forceUpdate(), 15);
            setTimeout(() => clearInterval(renderInterval), 150);
          },
          hideNumbers: true
        };
      });
      Fraction.Helpers.runAfterRender(() => this.forceUpdate());
      return <Tree data={renderOneNoteNotebooks} />;
    }
    return <Spinner />;
  }

  _selectSection(section) {
    this.setState({ selectedSection: section });
    MenuMixin._removeMenu();
  }

  _previewPrintNotes(selectedHighlights) {
    this.setState(
      { showPreviewOptions: true, selectedHighlights: selectedHighlights },
      this._updateModalSize
    );
  }

  _optionsPrintNotes(selectedHighlights) {
    this.setState(
      { showPreviewOptions: false, selectedHighlights: selectedHighlights },
      this._updateModalSize
    );
  }

  render() {
    if (this.state.accessToken && this.state.createNotebook) {
      return this.renderCreateNoteBook();
    } else if (this.state.accessToken && this.state.showExportComplete) {
      return this.renderExportComplete();
    } else if (this.state.notebookList) {
      return (
        <NotebookDialog
          {...this.props}
          isbn={this.props.isbn}
          showPreviewOptions={this.state.showPreviewOptions}
          optionsPrintNotes={this._optionsPrintNotes}
          previewPrintNotes={this._previewPrintNotes}
          renderPreviewNotes={this.renderPreviewNotes()}
          onSubmit={this._onSubmit}
          isOneNote={true}
          menuHTML={this.renderDefaultLoc()}
          menuTitle={
            this.state.selectedSection ? this.state.selectedSection.name : ""
          }
          signOutOneNote={this._signOutOneNote}
          createdByName={this.state.createdByName}
        />
      );
    }
    return this.renderSignIn();
  }
}

const _oneNoteDialog = isbn => {
  const title = i18n.t("one-note.send-one-note");
  return {
    title,
    definingClass: "notebook-modal",
    width: 565,
    height: 396,
    className: "one-note-modal",
    buttons: [],
    fullscreen: true,
    delegateButtons: false,
    closeCallback() {},
    content: <OneNoteContainer isbn={isbn} />
  };
};

const setupOneNote = isbn => {
  const setupDialog = _oneNoteDialog(isbn);
  if (Fraction.Helpers.isSmallScreen()) {
    setupDialog.definingClass =
      setupDialog.definingClass +
      " mobile-notebook-dialog, mobile-notebook-dialog-one-note";
  }
  Fraction.Helpers.showModal(setupDialog, $(".launch-one-note-button"));
};
export default setupOneNote;
